import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  props: {
    data: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  mounted () {
    this.renderChart(this.data,{
      legend: {
        labels: {
          generateLabels: function(chart) {
            return "";
          }
        }
      }
    })
  },
  watch: {
    data: function(val) {
      if(val) {
        this.renderChart(this.data,{
          legend: {
            labels: {
              generateLabels: function(chart) {
                return "";
              }
            }
          }
        })
      }
    }
  }
}